import { render, staticRenderFns } from "./About.vue?vue&type=template&id=3a2a0412&scoped=true&"
import script from "./About.vue?vue&type=script&lang=js&"
export * from "./About.vue?vue&type=script&lang=js&"
import style0 from "./About.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./About.vue?vue&type=style&index=1&id=3a2a0412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2a0412",
  null
  
)

export default component.exports